// Lightweight GA4 event helper. No-ops safely if gtag isn't loaded/blocked.
// Usage: trackEvent('lead_capture', { tool: 'Feasibility Pro Forma' })
export const trackEvent = (name, params = {}) => {
    try {
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
            window.gtag('event', name, params);
        }
    } catch (e) {
        /* analytics must never break the UI */
    }
};

export default trackEvent;
